import { AllergenStatus, DietaryAttributeStatus, DietaryCategory, RecipeV2 } from './recipeV2Types';

export interface RecipeBankAllergenFilter {
  code: string;
  status: AllergenStatus;
}

/** Match explicit compliance evidence. A missing attribute remains Unknown, never Free From. */
export const matchesRecipeBankAllergenFilter = (recipe: RecipeV2, filter: RecipeBankAllergenFilter): boolean => {
  const attribute = recipe.dietaryAttributes?.find((item) =>
    item.category === DietaryCategory.Allergen && item.code === filter.code);
  const status = attribute?.status ?? DietaryAttributeStatus.Unknown;

  if (filter.status === AllergenStatus.FreeFrom || filter.status === AllergenStatus.NotPresent) {
    return status === DietaryAttributeStatus.FreeFrom;
  }
  if (filter.status === AllergenStatus.Contains) return status === DietaryAttributeStatus.Contains;
  if (filter.status === AllergenStatus.MayContain) return status === DietaryAttributeStatus.MayContain;
  return status === DietaryAttributeStatus.Unknown;
};
